module.exports = __webpack_public_path__ + "img/member_ic2_account.543ad510.png";